import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { Controller } from "../Controller";
import { GambleModel } from "./GambleModel";
import { GambleView } from "./GambleView";
import { ComponentTypes } from "../../Components/ComponentTypes";

@engineComponent(ComponentTypes.Controller)
export class GambleController extends Controller {
    public static readonly StartReceived: string = "eventStartReceived";
    public static readonly HalveReceived: string = "eventHalveReceived";
    public static readonly SelectReceived: string = "eventSelectReceived";
    public static readonly WinCalculationFinished: string = "eventWinCalculationFinished";
    public static readonly AllWinsFinished: string = "eventAllWinsFinished";
    public static readonly Lose: string = "eventLose";
    public static readonly IntroFinished: string = "eventIntroFinished";
    public static readonly OutroFinished: string = "eventOutroFinished";

    protected _view: GambleView;
    protected _model: GambleModel;

    constructor() {
        super();
    }

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof GambleView) {
            this._view = view;
        } else {
            this.log("ERROR view is not instance of GambleView");
        }

        this._model = new GambleModel(this);
    }

    initReceived(): void {
        this._view.initReceived(this);
    }

    initIntro(): void {
        this._view.initIntro();
    }

    start(): void {
        this._model.start();
    }

    startReceived(): void {
        this._view.startReceived();
        this.emit(GambleController.StartReceived);
    }

    select(color: Communication.Game.Color): void {
        this._model.select(color);
    }

    selectReceived(): void {
        this._view.selectReceived();
        this.emit(GambleController.SelectReceived);
    }

    halve(): void {
        this._model.halve();
    }

    halveReceived(): void {
        this.emit(GambleController.HalveReceived);
    }

    winCalculationFinished(): void {
        this.emit(GambleController.WinCalculationFinished);
    }

    allWinsFinished(): void {
        this.emit(GambleController.AllWinsFinished);
    }

    lose(): void {
        this.emit(GambleController.Lose);
    }

    intro(long: boolean = false): void {
        this._view.intro(long);
    }

    introFinished(): void {
        this.emit(GambleController.IntroFinished);
    }

    outro(): void {
        this._view.outro();
    }

    outroFinished(): void {
        this.emit(GambleController.OutroFinished);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Gamble/GambleController.ts
 **/